import { render } from "./SetLocale.vue?vue&type=template&id=6ebc618f&scoped=true&ts=true"
import script from "./SetLocale.vue?vue&type=script&lang=ts"
export * from "./SetLocale.vue?vue&type=script&lang=ts"

import "./SetLocale.vue?vue&type=style&index=0&id=6ebc618f&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ebc618f"]])

export default __exports__